import React from 'react';
import { Spin } from 'antd';

// Spin only renders `tip` when it wraps content, so give it an empty box.
const LoadingSpinner = ({ size = 'large', tip = 'Loading...' }) => {
  return (
    <div className="loading-container">
      <Spin size={size} tip={tip}>
        <div style={{ width: 160, height: 80 }} />
      </Spin>
    </div>
  );
};

export default LoadingSpinner;
